import {
  collection, doc, addDoc, getDoc, getDocs,
  updateDoc, query, where, orderBy,
  serverTimestamp, arrayUnion, Timestamp,
} from 'firebase/firestore';
import { db } from '../utils/firebase';

const TICKETS = 'tickets';

export const getAllTickets = async () => {
  try {
    const snap = await getDocs(query(collection(db, TICKETS), orderBy('dateCreated', 'desc')));
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch {
    // If composite index not yet built, fall back without orderBy
    const snap = await getDocs(collection(db, TICKETS));
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) => {
        const aTs = a.dateCreated?.seconds ?? 0;
        const bTs = b.dateCreated?.seconds ?? 0;
        return bTs - aTs;
      });
  }
};

export const getTicketsByOrgId = async (orgId) => {
  const snap = await getDocs(
    query(collection(db, TICKETS), where('orgId', '==', orgId), orderBy('dateCreated', 'desc'))
  );
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const getTicketById = async (ticketId) => {
  const snap = await getDoc(doc(db, TICKETS, ticketId));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
};

export const createTicket = async ({ orgId, ticketHeader, ticketDescription, ticketSeverity, ticketType, senderName, clientEmail }) => {
  const now = Timestamp.now();
  const data = {
    orgId,
    dateCreated:        serverTimestamp(),
    dateUpdatedClient:  serverTimestamp(),
    dateUpdatedSupport: null,
    ticketHeader,
    ticketDescription,
    ticketStatus:   'Waiting for Support',
    ticketSeverity,
    ticketType,
    clientEmail:    clientEmail || '',
    messages: [{
      sender:     'client',
      senderName: senderName || 'Client',
      message:    ticketDescription,
      timestamp:  now,
    }],
  };
  const ref = await addDoc(collection(db, TICKETS), data);
  return { id: ref.id, ...data };
};

export const updateTicket = async (ticketId, updates) => {
  await updateDoc(doc(db, TICKETS, ticketId), {
    ...updates,
    dateUpdatedSupport: serverTimestamp(),
  });
};

export const addTicketMessage = async (ticketId, message, sender, senderName) => {
  const now = Timestamp.now();
  const updates = { messages: arrayUnion({ sender, senderName, message, timestamp: now }) };
  // Ball-in-court status flip: a support reply waits on the customer, a client reply waits on support
  if (sender === 'support') {
    updates.dateUpdatedSupport = serverTimestamp();
    updates.ticketStatus       = 'Waiting for Customer';
  } else {
    updates.dateUpdatedClient  = serverTimestamp();
    updates.ticketStatus       = 'Waiting for Support';
  }
  await updateDoc(doc(db, TICKETS, ticketId), updates);
};
